import { Box } from "@mui/material";
import { AppBar, TitlePortal } from "react-admin";

export const AuAppBar = () => (
  <AppBar color="primary" position="fixed">
    <TitlePortal />
    <Box
      sx={{
        display: { xs: "none", sm: "flex" },
        justifyContent: "right",
        flexGrow: 1,
      }}
    ></Box>
  </AppBar>
);
